import { DeepPartial } from 'redux';
import { SurveyState } from 'store/SurveyState';

export const latestReduxActions: { type: string; payload: any }[] = []; // Max 30 actions

export const wrappedReduxStateSnapshot: DeepPartial<{ state: SurveyState }> = {};
